<div #wrapper class="shopping-list-wrapper">
    <app-modal-header [text]="'Направи поръчка от VMV.bg'" [bold]="true" (close)="bsModalRef.hide()"></app-modal-header>

    <div class="modal-body" *ngIf="isSuccess === null" [ngClass]="isIOS() === true ? 'ios' : ''">
        <div class="vmv-logo-container">
            <img src="/assets/images/vmv_logo_big.png" class="vmv-logo" alt="VMV.bg" class="vmv-logo"/>
        </div>

        <ng-container *ngIf="!showMissingProducts">
            <div class="info-section">
                <!--            <label class="font-weight-bold">{{ 'send_to_friend_info_title' | localise }}</label>-->
                <p class="info-text">
                    С нашите партньори VMV.bg ви предоставям уникалната възможност да направите директна поръчка на
                    продуктите, които сте избрали и добавили в дневното си меню.<br/><br/>
                    След натискане на бутона "Създай поръчка" ще бъдете прехвърлени към сайта на VMV.bg, където ще може
                    да
                    завършите поръчката си и ще може да прегледате всички продукти, които сте добавили в дневното си
                    меню и
                    евентуално, ако жеалете да добавите още продукти към поръчката си.
                </p>
            </div>

            <p>
                <strong>
                    {{ getFromDate() }}
                </strong>
                -
                <strong>
                    {{ getToDate() }}
                </strong>
            </p>

            <div class="meals">
                <div *ngFor="let meal of meals" class="form-check">
                    <label class="form-check-label text-muted">
                        <input type="checkbox" class="form-check-input" checked
                               (input)="checkedMeals[meal.id] = !checkedMeals[meal.id]">
                        <i class="input-helper"></i>
                        <span>{{ meal.title }}</span>
                    </label>
                </div>
            </div>

            <button type="button" class="btn btn-primary btn-vmv-modal"
                    (click)="createVmvOrder()">
                Създай поръчка
            </button>
        </ng-container>

        <ng-container *ngIf="showMissingProducts">
            <div class="info-section">
                <p class="info-text warning-text">
                    Бяха намерени липсващи продукти в дневното ви меню, които не могат да бъдат добавени към поръчката.
                    Ако желате да направите частична поръчка само за наличните продукти, моля натиснете бутона по-долу.
                </p>
            </div>
            <div class="missing-products">
                <table>
                    <tbody>

                    <tr *ngFor="let product of missingProducts">
                        <td>{{ product.productTitle }}</td>
                        <td>
                            <ng-container *ngIf="product.typeCalculation == 'WEIGHT'">
                                {{ product.weight }} гр.
                            </ng-container>

                            <ng-container *ngIf="product.typeCalculation == 'QTY'">
                                {{ product.qty }} бр.
                            </ng-container>
                        </td>
                    </tr>

                    </tbody>
                </table>
            </div>

            <button type="button" class="btn btn-primary btn-vmv-modal"
                    (click)="createVmvOrder(true)">
                Създай поръчка само за наличните продукти
            </button>
        </ng-container>
    </div>

    <div class="modal-body" *ngIf="isSuccess === true">
        <app-alerts-components
                [type]="'success'"
                [disableClose]="true"
                [icon]="'fa fa-check-circle'"
                [id]="'send_vmv_success'"
                [title]="'send_to_friend_success_title' | localise"
                [message]="'Бяхте успешно пренасочен към VMV.bg със заредени продукти'"></app-alerts-components>
    </div>

    <div class="modal-body" *ngIf="isSuccess === false">
        <app-alerts-components
                [type]="'danger'"
                [disableClose]="true"
                [icon]="'fa fa-times-circle'"
                [id]="'send_to_friend_failed'"
                [title]="'send_to_friend_failed_title' | localise"
                [message]="'Моля, опитайте по-късно!'"></app-alerts-components>
    </div>
</div>
